import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import CsvFileUploadModalDialog from "./CsvFileUploadModalDialog";

const mapStateToProps = (state, ownProps) => {
  return {
    show: ownProps.show,
    onClose: ownProps.onClose,
    importRows: ownProps.importRows,
    question: ownProps.question,
    answer: ownProps.answer
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CsvFileUploadModalDialog);
